import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterMainComponent } from './components/main/main.component';
import { FooterShareIconsComponent } from './components/footer-share-icons/footer-share-icons.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FooterMainComponent,
    FooterShareIconsComponent
  ],
  exports: [
    FooterMainComponent
  ]
})
export class FooterModule {
  getComponent() {
    return FooterMainComponent;
  }
}
